import * as S from './styles'

const UserIcon = () => (
  <S.Wrapper>
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.5 21C38.5 23.7848 37.3938 26.4555 35.4246 28.4246C33.4555 30.3938 30.7848 31.5 28 31.5C25.2152 31.5 22.5445 30.3938 20.5754 28.4246C18.6062 26.4555 17.5 23.7848 17.5 21C17.5 18.2152 18.6062 15.5445 20.5754 13.5754C22.5445 11.6062 25.2152 10.5 28 10.5C30.7848 10.5 33.4555 11.6062 35.4246 13.5754C37.3938 15.5445 38.5 18.2152 38.5 21Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 28C0 20.5739 2.94999 13.452 8.20101 8.20101C13.452 2.94999 20.5739 0 28 0C35.4261 0 42.548 2.94999 47.799 8.20101C53.05 13.452 56 20.5739 56 28C56 35.4261 53.05 42.548 47.799 47.799C42.548 53.05 35.4261 56 28 56C20.5739 56 13.452 53.05 8.20101 47.799C2.94999 42.548 0 35.4261 0 28ZM28 3.5C23.3862 3.50025 18.8663 4.80327 14.9604 7.2591C11.0545 9.71492 7.92149 13.2237 5.92187 17.3817C3.92226 21.5396 3.13735 26.1777 3.65749 30.762C4.17764 35.3464 5.98169 39.6907 8.862 43.295C11.347 39.291 16.8175 35 28 35C39.1825 35 44.6495 39.2875 47.138 43.295C50.0183 39.6907 51.8224 35.3464 52.3425 30.762C52.8626 26.1777 52.0777 21.5396 50.0781 17.3817C48.0785 13.2237 44.9455 9.71492 41.0396 7.2591C37.1337 4.80327 32.6138 3.50025 28 3.5Z"
        fill="currentColor"
      />
    </svg>
  </S.Wrapper>
)

export default UserIcon
